var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEduBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.38453157645128627 0 0 0.38453157645128627 0 27.8991117320584)"
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m828.308,771.339c-5.585,6.748-11.361,13.337-17.32,19.758H124.419c-5.959-6.421-11.735-13.01-17.32-19.758h721.21Z",
    fill: "#3f3f3f",
    className: "svgShape color3f3f3f-1 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.491 143.888h-.001c-.388-.001-.701-.316-.701-.703h0s.012-4.217.012-4.217c.001-.388.316-.701.703-.701h.003c.387.001.7.316.7.703h0s-.012 4.217-.012 4.217c-.001.388-.316.701-.703.701ZM495.675 417.568c-.355-.045-.704-.316-.703-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.052-17.105h-.001c-.388-.001-.703-.317-.701-.704l.025-8.554c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.554c-.001.388-.316.701-.703.701Zm.051-17.106h-.001c-.388-.001-.703-.317-.701-.704l.025-8.552c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.552c-.001.388-.316.701-.703.701Zm.051-17.105h-.001c-.388-.001-.703-.317-.701-.704l.025-8.552c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.552c-.001.388-.316.701-.703.701Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.554c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.554c-.001.387-.316.7-.703.7Zm.051-17.106h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7.376-.052.704.316.703.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.052-17.105h-.001c-.388-.001-.703-.317-.701-.704l.025-8.552c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.552c-.001.388-.316.701-.703.701Zm.051-17.106h-.001c-.388-.001-.703-.317-.701-.704l.025-8.552c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.552c-.001.388-.316.701-.703.701Zm.051-17.105h-.001c-.388-.001-.703-.317-.701-.704l.025-8.552c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.552c-.001.388-.316.701-.703.701Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.106h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.388.288-.671.705-.7.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7ZM495.636 430.336h-.003c-.387-.001-.7-.316-.7-.703h0s.012-4.217.012-4.217c.001-.388.316-.701.703-.701h.001c.388.001.701.316.701.703h0s-.012 4.217-.012 4.217c-.001.388-.316.701-.703.701Z",
    fill: "#383838",
    className: "svgShape color383838-2 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.673 417.568c-.354-.045-.704-.316-.703-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.106c-.456-.012-.704-.316-.703-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.052-17.105h-.001c-.388-.001-.703-.317-.701-.704l.025-8.552c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.552c-.001.388-.316.701-.703.701Zm.051-17.105h-.001c-.388-.001-.703-.317-.701-.704l.025-8.552c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.552c-.001.388-.316.701-.703.701Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.106h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.052-17.105h-.001c-.388-.001-.703-.317-.701-.704l.025-8.552c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.552c-.001.388-.316.701-.703.701Zm.051-17.105h-.001c-.388-.001-.703-.317-.701-.704l.025-8.554c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.554c-.001.388-.316.701-.703.701Zm.051-17.106h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.387.316-.7.703-.7h.003c.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7Zm.052-17.105h-.001c-.388-.001-.703-.317-.701-.704l.025-8.554c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.554c-.001.388-.316.701-.703.701Zm.051-17.106h-.001c-.388-.001-.703-.317-.701-.704l.025-8.552c.001-.388.316-.701.703-.701h.001c.388.001.703.317.701.704l-.025 8.552c-.001.388-.316.701-.703.701Zm.051-17.105h-.003c-.387-.001-.701-.317-.7-.705l.026-8.552c.001-.388.288-.671.705-.7.387.001.701.317.7.705l-.026 8.552c-.001.387-.316.7-.703.7ZM231.015 560.243c-.386 0-.7-.312-.703-.697l-.03-4.216c-.003-.388.31-.705.697-.708h.005c.386 0 .7.312.703.697l.03 4.216c.003.388-.31.705-.697.708h-.005ZM230.926 547.386c-.386 0-.7-.312-.703-.697l-.06-8.642c-.003-.388.31-.705.697-.708h.005c.386 0 .7.312.703.697l.06 8.642c.003.388-.31.705-.697.708h-.005Zm-.119-17.283c-.386 0-.7-.312-.703-.697l-.06-8.642c-.003-.388.31-.705.697-.708h.005c.386 0 .7.312.703.697l.06 8.642c.003.388-.31.705-.697.708h-.005Zm-.121-17.282c-.386 0-.7-.312-.703-.699l-.059-8.642c-.003-.387.31-.704.699-.707h.004c.386 0 .7.312.703.697l.059 8.642c.003.388-.31.705-.699.708h-.004Zm-.119-17.283c-.386 0-.7-.312-.703-.699l-.059-8.64c-.003-.388.31-.705.699-.708h.004c.386 0 .7.312.703.699l.059 8.642c.003.387-.31.704-.699.707h-.004Zm-.119-17.283c-.386 0-.7-.312-.703-.697l-.06-8.642c-.003-.388.31-.705.697-.708h.005c.386 0 .7.312.703.697l.06 8.642c.003.388-.31.705-.697.708h-.005Zm-.119-17.283c-.386 0-.7-.312-.703-.697l-.06-8.64c-.003-.388.31-.705.697-.708h.005c.386 0 .7.312.703.697l.06 8.64c.003.388-.31.705-.697.708h-.005Zm-.121-17.282c-.386 0-.7-.312-.703-.699l-.059-8.642c-.003-.387.31-.704.697-.707h.005c.386 0 .7.312.703.697l.059 8.643c.003.387-.31.704-.697.707h-.005Zm-.119-17.283c-.386 0-.7-.312-.703-.699l-.059-8.642c-.003-.387.31-.704.699-.707h.004c.386 0 .7.312.703.699l.059 8.64c.003.388-.31.705-.699.708h-.004Zm-.119-17.283c-.386 0-.7-.312-.703-.697l-.06-8.642c-.003-.388.31-.705.697-.708h.005c.386 0 .7.312.703.697l.06 8.642c.003.388-.31.705-.697.708h-.005Zm-.119-17.282c-.386 0-.7-.312-.703-.697l-.06-8.642c-.003-.388.31-.705.697-.708h.005c.386 0 .7.312.703.697l.06 8.642c.003.388-.31.705-.697.708h-.005Zm-.121-17.283c-.386 0-.7-.312-.703-.697l-.059-8.643c-.003-.387.31-.704.699-.707h.004c.386 0 .7.312.703.699l.059 8.642c.003.387-.31.704-.699.707h-.004ZM229.61 357.278c-.386 0-.7-.312-.703-.697l-.03-4.216c-.001-.188.073-.368.204-.501s.312-.207.498-.207h4.216c.388 0 .703.314.703.703s-.314.703-.703.703h-3.508l.025 3.508c.003.388-.31.705-.697.708h-.005ZM736.286 353.062h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.751 0h-8.374c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.374c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.751 0h-8.374c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.374c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.751 0h-8.374c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.374c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.751 0h-8.374c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.374c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.751 0h-8.374c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.374c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.751 0h-8.374c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.374c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.751 0h-8.374c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.374c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.751 0h-8.374c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.374c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.751 0h-8.374c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.374c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703Zm-16.749 0h-8.375c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h8.375c.388 0 .703.314.703.703s-.314.703-.703.703ZM748.876 357.278c-.388 0-.703-.314-.703-.703v-3.513h-3.513c-.388 0-.703-.314-.703-.703s.314-.703.703-.703h4.216c.388 0 .703.314.703.703v4.216c0 .388-.314.703-.703.703ZM748.876 487.752c-.388 0-.703-.314-.703-.703v-8.154c0-.388.314-.703.703-.703s.703.314.703.703v8.154c0 .388-.314.703-.703.703Zm0-16.31c-.388 0-.703-.314-.703-.703v-8.154c0-.388.314-.703.703-.703s.703.314.703.703v8.154c0 .388-.314.703-.703.703Zm0-16.309c-.388 0-.703-.314-.703-.703v-8.154c0-.388.314-.703.703-.703s.703.314.703.703v8.154c0 .388-.314.703-.703.703Zm0-16.309c-.388 0-.703-.314-.703-.703v-8.156c0-.388.314-.703.703-.703s.703.314.703.703v8.156c0 .388-.314.703-.703.703Zm0-16.31c-.388 0-.703-.314-.703-.703v-8.154c0-.388.314-.703.703-.703s.703.314.703.703v8.154c0 .388-.314.703-.703.703Zm0-16.309c-.388 0-.703-.314-.703-.703v-8.154c0-.388.314-.703.703-.703s.703.314.703.703v8.154c0 .388-.314.703-.703.703Zm0-16.309c-.388 0-.703-.314-.703-.703v-8.156c0-.388.314-.703.703-.703s.703.314.703.703v8.156c0 .388-.314.703-.703.703Zm0-16.31c-.388 0-.703-.314-.703-.703v-8.154c0-.388.314-.703.703-.703s.703.314.703.703v8.154c0 .388-.314.703-.703.703ZM748.876 500.122c-.388 0-.703-.314-.703-.703v-4.216c0-.388.314-.703.703-.703s.703.314.703.703v4.216c0 .388-.314.703-.703.703Z",
    fill: "#383838",
    className: "svgShape color383838-3 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.54 750.152 127.817 736.235 136.446 740.298 121.523 755.447 113.404 751.15 113.54 750.152",
    fill: "#a0d1fc",
    className: "svgShape colorfcc6a0-4 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.562,752.604s-8.471-.875-9.313-7.125l-18.947,1.001,26.723,14.14,1.537-8.017Z",
    fill: "#444545",
    className: "svgShape color444445-5 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.784,
    height: 30.233,
    x: 107.622,
    y: 739.665,
    transform: "rotate(-62.115 109.014 754.781)",
    fill: "#ffffff",
    className: "svgShape colorffffff-6 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.383 749.368c-.058-.071-.099-.157-.115-.253-.322-2.014-1.038-3.307-1.045-3.32-.142-.253-.051-.562.204-.691.254-.129.577-.02.718.225.034.059.813 1.458 1.168 3.669.045.283-.152.537-.441.57-.191.021-.374-.061-.489-.2ZM110.475 749.283c-.058-.071-.099-.157-.115-.253-.322-2.014-1.038-3.307-1.045-3.32-.142-.253-.051-.562.204-.691.254-.128.579-.022.718.225.034.059.813 1.458 1.168 3.669.045.283-.152.537-.441.57-.191.021-.374-.061-.489-.2ZM107.568 749.198c-.059-.071-.099-.157-.115-.253-.323-2.014-1.039-3.307-1.045-3.32-.142-.253-.051-.562.204-.691.254-.128.579-.022.718.225.034.059.813 1.458 1.168 3.668.045.282-.152.537-.441.57-.191.021-.374-.061-.489-.2Z",
    fill: "#ffffff",
    className: "svgShape colorffffff-7 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.649 760.556 148.217 742.131 157.682 743.306 153.885 763.102 144.831 761.546 144.649 760.556",
    fill: "#a0d1fc",
    className: "svgShape colorfcc6a0-8 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.887,759.454s-8.323,1.806-11.068-3.871l-17.693,6.851,29.797,5.117-1.036-8.097Z",
    fill: "#444545",
    className: "svgShape color444445-9 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.784,
    height: 30.233,
    x: 140.397,
    y: 751.248,
    transform: "rotate(-80.255 141.791 766.366)",
    fill: "#ffffff",
    className: "svgShape colorffffff-10 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.257 759.86c-.078-.049-.143-.118-.188-.204-.933-1.814-2.016-2.82-2.027-2.83-.214-.196-.224-.519-.021-.72.202-.202.542-.199.753-.009.05.045 1.227 1.132 2.252 3.123.131.254.023.558-.241.679-.175.079-.374.059-.527-.038ZM141.467 760.684c-.078-.049-.143-.118-.188-.204-.933-1.814-2.016-2.82-2.027-2.83-.214-.196-.224-.519-.021-.72.201-.201.544-.201.753-.009.05.045 1.227 1.132 2.252 3.123.13.254.022.558-.241.679-.175.08-.374.059-.527-.038ZM138.677 761.508c-.078-.049-.143-.118-.188-.204-.934-1.813-2.016-2.819-2.027-2.829-.214-.196-.224-.518-.021-.72.201-.201.543-.201.753-.01.05.045 1.227 1.132 2.253 3.122.131.254.022.558-.241.679-.175.08-.375.059-.527-.038Z",
    fill: "#ffffff",
    className: "svgShape colorffffff-11 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.68 626.923 187.573 632.315 159.488 640.058 156.013 636.082 166.571 627.454 187.68 626.923",
    fill: "#e8e8e8",
    className: "svgShape colore8e8e8-12 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.163,615.585l20.517,11.339s-25.367,5.823-30.199,10.82l-.908-18.103,10.589-4.055Z",
    fill: "#cccccc",
    className: "svgShape colorcccccc-13 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.22,611.221s12.886-1.805,8.492-28.069l34.835,27.188s-.646,24.418-10.065,27.403l-33.261-26.522Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-14 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.22,611.221s-3.191,1.63-2.275,3.108l33.04,27.373s2.66.537,4.503-1.644l-2.006-2.315-33.261-26.522Z",
    fill: "#a6c7e3",
    className: "svgShape colore3d9a6-15 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.329,638.755c-.004-.008-.008-.016-.012-.024-.715-1.388-.715-3.032.119-4.351l1.606-2.54c.253-.4.126-.928-.275-1.179-1.592-.998-3.712-.517-4.717,1.072l-.718,1.135-2.726-6.247c-.367-.841-1.356-1.229-2.197-.862l-.475.207c-.412.18-.713.509-.872.897l-1.097-2.513c-.397-.91-1.466-1.329-2.376-.932l-.227.099c-.91.397-1.329,1.465-.932,2.375l.708,1.622c-.409-.161-.879-.167-1.311.021l-.398.174c-.863.376-1.26,1.39-.884,2.253l1.276,2.923c-.262-.043-.536-.029-.801.069l-.635.233c-.821.301-1.246,1.22-.945,2.041l3.26,8.883c.035.096.081.186.132.271,1.265,3.578,3.352,7.624,6.395,7.964l10.059-5.399c.02-1.532-.276-4.894-1.955-8.191Z",
    fill: "#a0d1fc",
    className: "svgShape colorfcc6a0-16 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.907,
    height: 33.04,
    x: 216.931,
    y: 596.047,
    rx: 8.12,
    ry: 8.12,
    transform: "rotate(-9.095 225.876 612.555)",
    fill: "#a0d1fc",
    className: "svgShape colorfcc6a0-17 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.681,579.071h17.984c6.384,0,11.566,5.183,11.566,11.566v16.365c0,8.155-6.621,14.775-14.775,14.775h0c-8.155,0-14.775-6.621-14.775-14.775v-27.931h0Z",
    transform: "rotate(2.372 224.45 600.393)",
    fill: "#a0d1fc",
    className: "svgShape colorfcc6a0-18 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.438,596.136c-1.074-2.554-2.965-4.687-5.367-6.054-2-3.877-5.96-6.604-10.63-6.798-6.924-.287-12.769,5.093-13.055,12.017-.118,2.847.734,5.504,2.246,7.675-.268,1.05-.436,2.141-.483,3.267-.361,8.705,6.404,16.053,15.108,16.414,8.705.361,16.053-6.404,16.414-15.108.182-4.392-1.453-8.435-4.233-11.413Z",
    fill: "#3d3d3d",
    className: "svgShape color3d3d3d-19 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.847,581.825c-.582-7.505-6.708-13.244-14.05-13.534.155-.892.215-1.813.141-2.757-.474-6.112-5.813-10.683-11.924-10.209-5.034.39-9.014,4.083-10,8.787-.486-.029-.978-.037-1.477.002-5.919.459-10.345,5.629-9.886,11.547.459,5.919,5.629,10.345,11.548,9.886,2.444-.189,4.626-1.191,6.322-2.709-.003.417.001.835.034,1.258.627,8.089,7.693,14.138,15.782,13.511,8.089-.627,14.138-7.693,13.511-15.782Z",
    fill: "#3d3d3d",
    className: "svgShape color3d3d3d-20 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.484,595.887s-1.359,2.982-2.862,4.576c-.433.459-.334,1.202.204,1.532.591.363,1.235.961,1.773,1.949l1.442-1.913-.556-6.144Z",
    fill: "#a0d1fc",
    className: "svgShape colorfcc6a0-21 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.092,714.632c-1.267,2.037-3.132,3.407-5.774,3.964-3.431.722-7.036.705-10.657.432-3.774-.281-7.558-.839-11.172-1.115-8.101-.618-16.202-1.233-24.307-1.783-8.464-.574-14.598-1.421-18.843-2.79-3.615-1.165-5.86-2.708-7.004-4.782-2.564-4.641.611-11.924,6.96-26.494,5.574-12.79,9.447-26.216,14.364-39.048,4.788-12.504,8.438-14.813,10.665-15.732,3.264-1.35,7.366-1.208,8.781-1.311,3.999-.296,6.682.139,8.742,1.387,5.621,3.406,22.87,17.312,26.815,44.763,2.645,18.402,6.11,34.995,1.431,42.508Z",
    fill: "#6face1",
    className: "svgShape colore1a36f-22 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.092,714.632c-2.103-.532-4.206-1.063-6.309-1.595-4.938-1.248-9.876-2.497-14.814-3.745-5.728-1.448-11.455-2.896-17.183-4.344-1.281,0-2.892-.731-4.14-1.047-1.36-.344-2.741-.619-4.084-1-2.135-.607-4.27-1.211-6.405-1.816-1.877-.532-3.928-1.169-5.519-2.362-1.376-.864-2.769-1.7-4.176-2.512-4.014-2.317-8.142-4.443-12.378-6.323-5.012-2.225-10.194-4.124-15.534-5.397-5.222-1.245-10.679-1.922-16.037-1.281-5.121.613-10.028,2.551-13.886,6.026-2.497,2.249-4.471,5.021-5.98,8.014,0,0-19.516,35.075-20.661,45.649-.05.461.183.904.583,1.137l12.305,7.185c.519.303,1.174.238,1.623-.161l9.467-8.405-1.339,6.779c-.096.489.233.959.725,1.035l12.438,1.92c.685.106,1.339-.326,1.51-.998l7.861-30.852s33.513,54.377,63.807,45.121c0,0,28.775-4.186,38.124-51.027Z",
    fill: "#2d2d2d",
    className: "svgShape color2d2d2d-23 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.933,657.806s-19.411,21.307-38.633,29.552c-9.583,4.11-20.733,1.508-27.564-6.37-8.253-9.518-21.285-23.985-17.377-33.526l16.035-5.284,17.843,23.517c.987,1.197,2.75,1.385,3.968.424l29.467-23.263,16.261,14.949Z",
    fill: "#6face1",
    className: "svgShape colore1a36f-24 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.927,645.821l15.96-5.32c.493-.164,1.033.044,1.287.497l.698,1.244c.335.597.039,1.35-.611,1.56l-16.433,5.31c-.623.201-1.281-.192-1.398-.836l-.225-1.234c-.097-.53.212-1.051.723-1.221Z",
    fill: "#545454",
    className: "svgShape color545454-25 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.213,
    height: 18.256,
    x: 776.143,
    y: 743.839,
    rx: 3.961,
    ry: 3.961,
    fill: "#9ec8ed",
    className: "svgShape coloreda99e-26 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m802.975,769.752l-26.876.071c-.749.002-1.353-.612-1.339-1.361l.148-7.768c.006-.295-.033-.593-.149-.865-.265-.622-.433-1.969,3.429-1.508l4.106.009s1.799-3.008,5.127-1.327c0,0,10.543,8.288,13.529,8.345,0,0,4.626.088,2.764,3.957-.134.279-.428.446-.738.447Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-27 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.584 760.394s-.36 2.132-3.467 1.948M793.021 761.385s-.36 2.132-3.467 1.948M794.529 762.47s-.36 2.132-3.467 1.948",
    fill: "none",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".352px",
    className: "svgStroke colorStroke303030-28 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.262 759.185c1.17 2.31 1.424 5.21.446 7.629.498-2.55.263-5.134-.446-7.629h0ZM776.94 759.335c1.17 2.31 1.424 5.21.446 7.629.498-2.55.263-5.134-.446-7.629h0Z",
    fill: "#303030",
    className: "svgShape color303030-29 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.213,
    height: 18.256,
    x: 732.224,
    y: 743.5,
    rx: 3.961,
    ry: 3.961,
    fill: "#9ec8ed",
    className: "svgShape coloreda99e-30 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m759.056,769.413l-26.876.071c-.749.002-1.353-.612-1.339-1.361l.148-7.768c.006-.295-.033-.593-.149-.865-.265-.622-.433-1.969,3.429-1.508l4.106.009s1.799-3.008,5.127-1.327c0,0,10.543,8.288,13.529,8.345,0,0,4.626.088,2.764,3.957-.134.279-.428.446-.738.447Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-31 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.664 760.056s-.36 2.132-3.467 1.948M749.102 761.047s-.36 2.132-3.467 1.948M750.61 762.131s-.36 2.132-3.467 1.948",
    fill: "none",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".352px",
    className: "svgStroke colorStroke303030-32 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.342 758.846c1.17 2.31 1.424 5.21.446 7.63.498-2.55.263-5.134-.446-7.63h0ZM733.02 758.996c1.17 2.311 1.424 5.21.446 7.63.498-2.55.263-5.134-.446-7.63h0Z",
    fill: "#303030",
    className: "svgShape color303030-33 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.226,
    height: 31.116,
    x: 741.424,
    y: 538.276,
    rx: 6.495,
    ry: 6.495,
    transform: "rotate(-180 749.037 553.835)",
    fill: "#a5ccef",
    className: "svgShape colorefbca5-34 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m756.65,550.316s-4.588,4.319-15.293,0c0,0-2.039,7.188,15.293,8.391v-8.391Z",
    fill: "#9ac0e2",
    className: "svgShape colore2af9a-35 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m742.515,513.746h9.22c4.504,0,8.161,3.657,8.161,8.161v23.041c0,3.959-3.214,7.173-7.173,7.173h-5.974c-6.504,0-11.784-5.28-11.784-11.784v-19.041c0-4.167,3.383-7.55,7.55-7.55Z",
    transform: "rotate(-180 747.43 532.933)",
    fill: "#a5ccef",
    className: "svgShape colorefbca5-36 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m719.525,518.933c.853-7.147,6.934-12.389,13.959-12.375-.112-.858-.133-1.741-.026-2.64.694-5.821,5.976-9.977,11.797-9.282,4.794.572,8.451,4.258,9.207,8.791.466-.008.936.003,1.411.06,5.637.673,9.661,5.787,8.989,11.424-.673,5.637-5.787,9.661-11.424,8.989-2.328-.278-4.373-1.321-5.933-2.838-.014.398-.034.797-.082,1.2-.919,7.704-7.91,13.204-15.613,12.284-7.704-.919-13.204-7.91-12.284-15.613Z",
    fill: "#3d3d3d",
    className: "svgShape color3d3d3d-37 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m752.03,511.985c3.788-1.391,7.953.314,9.733,3.827.4-.274.836-.509,1.312-.684,3.085-1.133,6.504.449,7.637,3.534.933,2.541.022,5.305-2.051,6.835.123.231.236.468.329.72,1.097,2.987-.435,6.299-3.422,7.396-2.987,1.097-6.299-.435-7.396-3.422-.453-1.234-.452-2.521-.091-3.686-.202.094-.407.186-.621.264-4.083,1.5-8.608-.594-10.108-4.677s.594-8.608,4.677-10.108Z",
    fill: "#3d3d3d",
    className: "svgShape color3d3d3d-38 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 734.363,
    cy: 535.589,
    rx: 4.112,
    ry: 2.906,
    transform: "rotate(-85.736 734.362 535.59)",
    fill: "#a5ccef",
    className: "svgShape colorefbca5-39 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 734.363,
    cy: 535.589,
    rx: 2.613,
    ry: 1.847,
    transform: "rotate(-85.736 734.362 535.59)",
    fill: "#99b5ce",
    className: "svgShape colorcea899-40 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 760.871,
    cy: 534.646,
    rx: 4.112,
    ry: 2.906,
    transform: "rotate(-85.736 760.87 534.646)",
    fill: "#a5ccef",
    className: "svgShape colorefbca5-41 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 760.871,
    cy: 534.646,
    rx: 2.613,
    ry: 1.847,
    transform: "rotate(-85.736 760.87 534.646)",
    fill: "#99b5ce",
    className: "svgShape colorcea899-42 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m728.488,754.95h17.107l3.64-120.476h0c1.264,0,2.345.906,2.567,2.15l21.091,118.326h13.831l-14.195-117.564s-1.82-19.655-10.919-30.21h-26.934s-9.099,19.655-8.007,33.122l1.82,114.652Z",
    fill: "#3b4146",
    className: "svgShape color3b4146-43 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m710.824,581.632l9.975,5.59,7.902-7.181c.587-.533,1.531-.218,1.68.56l5.09,26.576h26.934l5.824-27.662,7.279-.728s.728-20.747-18.927-20.019l-4.004,9.463-11.295-10.486s-9.348,1.685-30.459,23.887Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-44 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m743.59,611.94l-.037-.229c-.098-.603.316-1.177.919-1.274l8.017-1.3-8.857.943c-.588.063-1.12-.367-1.182-.955l-.014-.133c-.063-.588.367-1.12.955-1.182l6.422-.684-5.348.048c-.638.006-1.164-.511-1.169-1.149v-.109c-.007-.638.51-1.164,1.148-1.169,0,0,9.501-.085,9.504-.085l1.284-.151-2.293-1.646c-.934-.67-1.155-1.98-.496-2.919.217-.309.651-.375.958-.155l5.898,4.232c.005.004.012.005.018.005l19.893-2.348c.812-.096-7.201-15.304-11.733-20.902-.457-.564.032-1.343.754-1.261l9.081-4.343c.015.009,3.746-.009,3.761,0l5.217,10.205c3.519,8.148,10.294,18.356,1.213,25.464,0,0-30.137,1.66-30.147,1.661l-9.167,2.616c-.513.147-1.099-.06-1.32-.547-.27-.594.061-1.27.664-1.443l5.379-1.535.006-.042-8.053,1.306c-.603.098-1.177-.316-1.274-.919Z",
    fill: "#a5ccef",
    className: "svgShape colorefbca5-45 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m768.794,562.307s10.457,2.673,14.144,16.516l-11.303,8.054-4.16-6.101-5.573-8.88,6.892-9.589Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-46 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m728.595,588.103s11.756-10.409,26.739-.488c0,0,11.526-7.481,23.051-.855l-2.766,30.376s-17.288-5.063-45.641,0l-1.383-29.033Z",
    fill: "#e3effa",
    className: "svgShape colorfaf8e3-47 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m728.595,590.463s11.756-10.409,26.739-.488c0,0,11.526-7.481,23.051-.855l-2.766,30.376s-17.288-5.063-45.641,0l-1.383-29.033Z",
    fill: "#696b6d",
    className: "svgShape color696b6d-48 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "756.429 589.588 756.202 617.251 754.182 617.251 754.182 589.588 755.219 590.473 756.429 589.588",
    fill: "#85b4dd",
    className: "svgShape colorddc385-49 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m774.15 594.082-1.47 7.348s-5.792-1.729-12.534 0l-1.037-7.78s9.336-3.717 15.041.432ZM730.583 618.458s14.032-2.997 22.561-2.075c0 0-.605-.605 0-.994 0 0-4.106-1.124-22.561 2.204 0 0-.605.519 0 .864ZM774.958 618.801s-11.367-2.951-18.366-2.452c0 0 .514-.486.032-.831 0 0 3.391-.808 18.362 2.56 0 0 .478.453-.028.722Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-50 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751.57,606.853l-8.524.436c-.247.013-.48.077-.689.18l.06-1.37c.074-1.694-1.251-3.141-2.945-3.216-.563-.025-1.045.416-1.069.979l-.192,4.367-20.488-10.507c-1.395-.716-1.907-2.454-1.122-3.811l4.199-6.69-9.975-5.59-5.551,9.19c-2.322,4.656-3.546,11.907,1.275,13.865l29.296,11.898c.943.383,3.174.947,3.318,1.011l7.808,3.446c.894.394,1.948-.014,2.342-.908.395-.894-.014-1.948-.908-2.342l-.915-.404,1.686.445c.945.249,1.921-.32,2.171-1.264.249-.945-.32-1.921-1.264-2.171l-.922-.243,2.475.109c.976.043,1.81-.721,1.853-1.697.043-.976-.721-1.81-1.697-1.853l-3.317-.146,3.276-.168c.976-.05,1.733-.889,1.683-1.865-.05-.976-.889-1.733-1.865-1.683Z",
    fill: "#add4f6",
    className: "svgShape colorf6c7ad-51 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.602,722.474v22.122c0,8.466,6.776,15.319,15.089,15.319h174.119c0,5.566-4.444,10.078-9.927,10.078h-412.837c-14.199,0-25.71-11.686-25.71-26.102v-20.736c0-14.402,11.5-26.077,25.686-26.077h412.862c5.482,0,9.927,4.512,9.927,10.078h0s-174.119,0-174.119,0c-8.313,0-15.089,6.853-15.089,15.319Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-52 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m715.81,707.155v52.76h-173.873c-8.469,0-15.335-6.475-15.335-14.488v-23.785c0-8.012,6.866-14.488,15.335-14.488h173.873Z",
    fill: "#e9eaea",
    className: "svgShape coloreaeae9-53 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 715.81,
    x2: 556.258,
    y1: 718.419,
    y2: 718.419,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".873px",
    className: "svgStroke colorStroke231f20-54 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 715.81,
    x2: 603.134,
    y1: 730.781,
    y2: 730.781,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".734px",
    className: "svgStroke colorStroke231f20-55 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 715.81,
    x2: 648.7,
    y1: 743.143,
    y2: 743.143,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".566px",
    className: "svgStroke colorStroke231f20-56 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.821,697.077h9.093c-13.855,0-25.19,11.336-25.19,25.19v22.536c0,13.855,11.336,25.19,25.19,25.19h-9.093c-13.855,0-25.19-11.336-25.19-25.19v-22.536c0-13.855,11.335-25.19,25.19-25.19Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-57 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.657,697.077h9.093c-13.855,0-25.19,11.336-25.19,25.19v22.536c0,13.855,11.336,25.19,25.19,25.19h-9.093c-13.855,0-25.19-11.336-25.19-25.19v-22.536c0-13.855,11.335-25.19,25.19-25.19Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-58 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.101,656.702v18.947c0,7.251-5.804,13.121-12.924,13.121h-149.13c0,4.767,3.807,8.632,8.502,8.632h353.589c12.162,0,22.021-10.009,22.021-22.356v-17.76c0-12.335-9.85-22.335-22-22.335h-353.61c-4.696,0-8.502,3.865-8.502,8.632h0s149.13,0,149.13,0c7.12,0,12.924,5.87,12.924,13.121Z",
    fill: "#a6c7e3",
    className: "svgShape colore3d9a6-59 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.047,643.582v45.188h148.92c7.254,0,13.134-5.546,13.134-12.408v-20.371c0-6.862-5.88-12.408-13.134-12.408h-148.92Z",
    fill: "#e9eaea",
    className: "svgShape coloreaeae9-60 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.047,
    x2: 441.701,
    y1: 653.229,
    y2: 653.229,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".748px",
    className: "svgStroke colorStroke231f20-61 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.047,
    x2: 401.553,
    y1: 663.817,
    y2: 663.817,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".629px",
    className: "svgStroke colorStroke231f20-62 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.047,
    x2: 362.526,
    y1: 674.405,
    y2: 674.405,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".485px",
    className: "svgStroke colorStroke231f20-63 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635.64,634.95h-7.788c11.866,0,21.575,9.709,21.575,21.575v19.302c0,11.866-9.709,21.575-21.575,21.575h7.788c11.866,0,21.575-9.709,21.575-21.575v-19.302c0-11.866-9.709-21.575-21.575-21.575Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-64 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m615.225,634.95h-7.788c11.866,0,21.575,9.709,21.575,21.575v19.302c0,11.866-9.709,21.575-21.575,21.575h7.788c11.866,0,21.575-9.709,21.575-21.575v-19.302c0-11.866-9.709-21.575-21.575-21.575Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-65 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 257.722,
    height: 165.717,
    x: 362.401,
    y: 6.752,
    rx: 11.061,
    ry: 11.061,
    fill: "#85b4dd",
    className: "svgShape colorddc385-66 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 374.897,
    y: 58.782,
    fill: "#efefef",
    className: "svgShape colorefefef-67 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 374.897,
    y: 95.456,
    fill: "#efefef",
    className: "svgShape colorefefef-68 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 374.897,
    y: 132.13,
    fill: "#efefef",
    className: "svgShape colorefefef-69 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 423.435,
    y: 22.108,
    fill: "#efefef",
    className: "svgShape colorefefef-70 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 423.435,
    y: 58.782,
    fill: "#efefef",
    className: "svgShape colorefefef-71 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 423.435,
    y: 95.456,
    fill: "#efefef",
    className: "svgShape colorefefef-72 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 423.435,
    y: 132.13,
    fill: "#efefef",
    className: "svgShape colorefefef-73 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 471.973,
    y: 22.108,
    fill: "#efefef",
    className: "svgShape colorefefef-74 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 471.973,
    y: 58.782,
    fill: "#efefef",
    className: "svgShape colorefefef-75 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 471.973,
    y: 95.456,
    fill: "#efefef",
    className: "svgShape colorefefef-76 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 471.973,
    y: 132.13,
    fill: "#efefef",
    className: "svgShape colorefefef-77 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 520.511,
    y: 22.108,
    fill: "#efefef",
    className: "svgShape colorefefef-78 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 520.511,
    y: 58.782,
    fill: "#efefef",
    className: "svgShape colorefefef-79 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 520.511,
    y: 95.456,
    fill: "#efefef",
    className: "svgShape colorefefef-80 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 520.511,
    y: 132.13,
    fill: "#efefef",
    className: "svgShape colorefefef-81 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 569.049,
    y: 22.108,
    fill: "#efefef",
    className: "svgShape colorefefef-82 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 569.049,
    y: 58.782,
    fill: "#efefef",
    className: "svgShape colorefefef-83 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 569.049,
    y: 95.456,
    fill: "#efefef",
    className: "svgShape colorefefef-84 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.577,
    height: 24.983,
    x: 569.049,
    y: 132.13,
    fill: "#efefef",
    className: "svgShape colorefefef-85 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 371.993,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 374.996 6.75)",
    fill: "#6face1",
    className: "svgShape colore1a36f-86 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 384.433,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 387.437 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-87 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 396.873,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 399.878 6.75)",
    fill: "#6face1",
    className: "svgShape colore1a36f-88 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 409.313,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 412.317 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-89 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 421.753,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 424.757 6.751)",
    fill: "#6face1",
    className: "svgShape colore1a36f-90 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 434.193,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 437.196 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-91 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 446.633,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 449.637 6.751)",
    fill: "#6face1",
    className: "svgShape colore1a36f-92 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 459.073,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 462.078 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-93 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 471.513,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 474.517 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-94 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 483.953,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 486.957 6.75)",
    fill: "#6face1",
    className: "svgShape colore1a36f-95 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 496.393,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 499.397 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-96 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 509.282,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 512.287 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-97 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 521.722,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 524.726 6.751)",
    fill: "#6face1",
    className: "svgShape colore1a36f-98 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 534.162,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 537.166 6.75)",
    fill: "#6face1",
    className: "svgShape colore1a36f-99 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 546.602,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 549.605 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-100 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 559.042,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 562.046 6.75)",
    fill: "#6face1",
    className: "svgShape colore1a36f-101 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 571.482,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 574.485 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-102 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 583.922,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 586.926 6.75)",
    fill: "#6face1",
    className: "svgShape colore1a36f-103 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 596.362,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 599.365 6.752)",
    fill: "#6face1",
    className: "svgShape colore1a36f-104 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 14.391,
    x: 608.802,
    y: -0.444,
    rx: 3.007,
    ry: 3.007,
    transform: "rotate(26.556 611.805 6.751)",
    fill: "#6face1",
    className: "svgShape colore1a36f-105 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.063 30.799v2.513h2.956v1.146h-2.956v2.623h3.325v1.146h-4.729v-8.571h4.729v1.145h-3.325ZM436.019 34.789l2.192 3.437h-1.589l-1.465-2.303-1.379 2.303h-1.466l2.192-3.338-2.192-3.448h1.589l1.465 2.304 1.379-2.304h1.466l-2.192 3.35ZM439.215 32.991c.284-.525.669-.934 1.158-1.226.489-.291 1.028-.437 1.62-.437.534 0 1 .104 1.398.313.398.21.716.471.954.782v-.985h1.417v6.786h-1.417v-1.01c-.238.32-.562.587-.973.801-.411.213-.879.32-1.404.32-.583 0-1.117-.15-1.601-.45-.485-.3-.868-.718-1.152-1.256-.283-.538-.425-1.147-.425-1.829s.142-1.285.425-1.811Zm4.84.616c-.193-.345-.446-.607-.757-.788-.312-.181-.649-.271-1.01-.271s-.698.089-1.01.265c-.312.177-.564.436-.757.776s-.29.745-.29 1.213.097.879.29 1.231c.193.354.447.622.764.807.316.185.65.277 1.003.277.361 0 .698-.09 1.01-.271.312-.181.564-.445.757-.795.193-.349.289-.757.289-1.226s-.096-.874-.289-1.219ZM457.257 31.661c.423.222.755.551.998.985.242.436.363.961.363 1.576v4.003h-1.392v-3.793c0-.607-.152-1.073-.456-1.398-.304-.324-.718-.486-1.244-.486s-.942.162-1.25.486c-.308.325-.462.791-.462 1.398v3.793h-1.392v-3.793c0-.607-.152-1.073-.456-1.398-.304-.324-.718-.486-1.244-.486s-.942.162-1.25.486c-.308.325-.462.791-.462 1.398v3.793h-1.404v-6.786h1.404v.776c.23-.279.521-.497.875-.653.353-.155.73-.233 1.133-.233.542 0 1.026.115 1.453.345.427.229.755.562.985.997.205-.41.525-.736.961-.979.435-.242.903-.363 1.404-.363.534 0 1.012.11 1.435.332Z",
    fill: "#383838",
    className: "svgShape color383838-106 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.231,587.229c-10.553-11.068-11.325-14.929,5.148-31.144,16.473-16.216,13.899-38.609,13.899-38.609l-31.646-.609v-.035l-.908.018-.908-.018v.035l-31.646.609s-2.574,22.393,13.899,38.609c16.473,16.216,15.701,20.076,5.148,31.144-10.553,11.068-24.967,21.878-24.452,42.212h75.917c.515-20.334-13.899-31.144-24.452-42.212Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-107 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 85.665,
    height: 8.494,
    x: 314.892,
    y: 626.459,
    rx: 3.568,
    ry: 3.568,
    fill: "#6face1",
    className: "svgShape colore1a36f-108 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.049 555.164c4.869 1.497 12.997 2.684 23.66-.446 1.013-.297 1.734.978.948 1.683-3.93 3.524-9.64 9.403-12.637 16.066-.349.775-1.462.765-1.803-.014-1.371-3.121-4.561-9.041-11.139-15.628-.728-.729-.013-1.964.973-1.661ZM358.815 580.14s-3.391 6.86.394 6.86c3.391 0-.394-6.86-.394-6.86ZM353.035 589.673s-3.39 6.86.394 6.86c3.39 0-.394-6.86-.394-6.86ZM388.407 626.45s-3.541-17.705-14.99-25.141c-11.449-7.436-16.597 17.173-31.279 11.449-13.928-5.43-14.379 13.686-14.379 13.686l60.649.006Z",
    fill: "#a6c7e3",
    className: "svgShape colore3d9a6-109 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 85.665,
    height: 8.494,
    x: 314.892,
    y: 512.457,
    rx: 3.568,
    ry: 3.568,
    fill: "#6face1",
    className: "svgShape colore1a36f-110 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.726,348.776v12.338c0,4.721-3.779,8.544-8.415,8.544h-97.108c0,3.104,2.479,5.621,5.536,5.621h230.243c7.919,0,14.339-6.518,14.339-14.558v-11.565c0-8.032-6.414-14.544-14.325-14.544h-230.257c-3.058,0-5.536,2.516-5.536,5.621h0s97.108,0,97.108,0c4.636,0,8.415,3.822,8.415,8.544Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-111 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.202,340.233v29.425h96.971c4.723,0,8.552-3.611,8.552-8.08v-13.265c0-4.468-3.829-8.08-8.552-8.08h-96.971Z",
    fill: "#e9eaea",
    className: "svgShape coloreaeae9-112 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.202,
    x2: 455.186,
    y1: 346.515,
    y2: 346.515,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".487px",
    className: "svgStroke colorStroke231f20-113 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.202,
    x2: 429.043,
    y1: 353.409,
    y2: 353.409,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".409px",
    className: "svgStroke colorStroke231f20-114 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.202,
    x2: 403.631,
    y1: 360.304,
    y2: 360.304,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".316px",
    className: "svgStroke colorStroke231f20-115 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.472,334.612h-5.071c7.727,0,14.049,6.322,14.049,14.049v12.568c0,7.727-6.322,14.049-14.049,14.049h5.071c7.727,0,14.049-6.322,14.049-14.049v-12.568c0-7.727-6.322-14.049-14.049-14.049Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-116 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.179,334.612h-5.071c7.727,0,14.049,6.322,14.049,14.049v12.568c0,7.727-6.322,14.049-14.049,14.049h5.071c7.727,0,14.049-6.322,14.049-14.049v-12.568c0-7.727-6.322-14.049-14.049-14.049Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-117 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.592,320.579v8.474c0,3.243,2.596,5.868,5.78,5.868h66.697c0,2.132-1.702,3.861-3.803,3.861h-158.139c-5.439,0-9.848-4.477-9.848-9.999v-7.943c0-5.517,4.405-9.989,9.839-9.989h158.148c2.1,0,3.803,1.728,3.803,3.861h0s-66.697,0-66.697,0c-3.184,0-5.78,2.625-5.78,5.868Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-118 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.069,314.711v20.21h-66.603c-3.244,0-5.874-2.48-5.874-5.549v-9.111c0-3.069,2.63-5.549,5.874-5.549h66.603Z",
    fill: "#e9eaea",
    className: "svgShape coloreaeae9-119 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 581.069,
    x2: 519.952,
    y1: 319.025,
    y2: 319.025,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".335px",
    className: "svgStroke colorStroke231f20-120 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 581.069,
    x2: 537.908,
    y1: 323.761,
    y2: 323.761,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".281px",
    className: "svgStroke colorStroke231f20-121 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 581.069,
    x2: 555.362,
    y1: 328.496,
    y2: 328.496,
    fill: "none",
    stroke: "#1f2123",
    strokeMiterlimit: 10,
    strokeWidth: ".217px",
    className: "svgStroke colorStroke231f20-122 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.215,310.85h3.483c-5.307,0-9.649,4.342-9.649,9.649v8.632c0,5.307,4.342,9.649,9.649,9.649h-3.483c-5.307,0-9.649-4.342-9.649-9.649v-8.632c0-5.307,4.342-9.649,9.649-9.649Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-123 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.345 310.85h3.483c-5.307 0-9.649 4.342-9.649 9.649v8.632c0 5.307 4.342 9.649 9.649 9.649h-3.483c-5.307 0-9.649-4.342-9.649-9.649v-8.632c0-5.307 4.342-9.649 9.649-9.649ZM463.544 208.342h67.901c2.182 0 3.954 1.772 3.954 3.954v95.233c0 2.182-1.772 3.954-3.954 3.954h-67.901v-103.14h0Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-124 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.278,208.342h3.266v103.14h-3.266c-2.941,0-5.329-2.388-5.329-5.329v-92.482c0-2.941,2.388-5.329,5.329-5.329Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-125 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.595,
    height: 1.977,
    x: 454.949,
    y: 215.819,
    fill: "#85b4dd",
    className: "svgShape colorddc385-126 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.595,
    height: 1.977,
    x: 454.949,
    y: 219.171,
    fill: "#85b4dd",
    className: "svgShape colorddc385-127 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.595,
    height: 1.977,
    x: 454.949,
    y: 300.652,
    fill: "#85b4dd",
    className: "svgShape colorddc385-128 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.063,
    height: 103.14,
    x: 463.544,
    y: 208.342,
    fill: "#536d84",
    className: "svgShape color538481-129 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.106,251.934l.038-.008c-1.242-10.084-9.097-18.12-19.093-19.634l-.007.054c-.929-.13-1.874-.209-2.835-.22h0c-.025,0-.05-.001-.075-.001-.031,0-.063,0-.094,0h-.008c-.028,0-.057,0-.086,0-.025,0-.05.001-.075.001h0c-12.198.141-22.043,10.073-22.043,22.305,0,6.609,2.874,12.546,7.441,16.63h0c1.309,1.171,2.756,2.189,4.315,3.027,1.819,1.652,3.53,3.884,3.562,6.454v3.139h13.785v-3.139c.032-2.571,1.744-4.802,3.563-6.454,1.559-.837,3.006-1.855,4.314-3.026h0c4.567-4.084,7.441-10.022,7.441-16.631,0-.845-.053-1.676-.145-2.496Zm-21.448-12.193c.178-.039.362-.063.551-.063.026,0,.05.009.077.01-.1.017-.217.032-.378.032-.085,0-.167.011-.25.021Zm1.266.048c.059.017.112.045.169.066l-.018.145c-.06-.087-.109-.156-.151-.211Zm9.04,12.784c.095-.237.227-.451.384-.646h.093c-.194.186-.348.408-.478.646Zm4.84,1.545c.013-.105.032-.207.032-.315,0-.059.018-.099.032-.144-.008.157-.028.311-.064.459Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-130 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.87,237.52s-13.977,2.333-13.872,19.627c0,0-7.756-17.948,13.872-19.627Z",
    fill: "#a6c7e3",
    opacity: 0.44,
    className: "svgShape colore3d9a6-131 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.353,283.653c.116-3.793-.198-7.483-1.195-11.152-1.312-4.828-8.959-15.339,2.976-15.452.521-.005.522-.815,0-.81-1.379.013-6.729,1.532-3.914,3.91,2.025,1.71,3.413-1.311,2.072-2.869-2.199-2.556-5.479.505-5.904,2.81-.47,2.548,1.005,4.867,1.972,7.088,2.311,5.307,3.359,10.683,3.182,16.474-.016.522.794.521.81,0h0Z",
    fill: "#6face1",
    className: "svgShape colore1a36f-132 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.199,283.653c-.177-5.791.871-11.167,3.182-16.474.959-2.202,2.42-4.51,1.979-7.034-.405-2.319-3.69-5.447-5.911-2.864-1.183,1.375-.422,3.951,1.542,3.104.835-.36,1.155-.936,1.033-1.951-.248-2.062-2.909-2.18-4.417-2.194-.522-.005-.522.805,0,.81,11.935.113,4.288,10.624,2.976,15.452-.997,3.669-1.311,7.358-1.195,11.152.016.52.826.522.81,0h0Z",
    fill: "#6face1",
    className: "svgShape colore1a36f-133 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.257,279.769v7.914c0,.952.772,1.723,1.723,1.723h4.655l.312,2.435h4.372l.312-2.435h4.655c.952,0,1.723-.772,1.723-1.723v-7.914h-17.752Z",
    fill: "#3a3a3a",
    className: "svgShape color3a3a3a-134 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.516,
    height: 3.208,
    x: 489.376,
    y: 278.325,
    rx: 1.224,
    ry: 1.224,
    fill: "#6face1",
    className: "svgShape colore1a36f-135 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.516,
    height: 3.208,
    x: 489.376,
    y: 282.065,
    rx: 1.224,
    ry: 1.224,
    fill: "#6face1",
    className: "svgShape colore1a36f-136 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.516,
    height: 3.208,
    x: 489.376,
    y: 285.805,
    rx: 1.224,
    ry: 1.224,
    fill: "#6face1",
    className: "svgShape colore1a36f-137 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 451.54,
    cy: 644.639,
    rx: 20.086,
    ry: 7.059,
    fill: "#494a4a",
    className: "svgShape color49494a-138 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.098,638.673h14.947c2.023,0,3.665,1.642,3.665,3.665v4.601c0,2.023-1.642,3.665-3.665,3.665h-14.947c-3.293,0-5.966-2.673-5.966-5.966h0c0-3.293,2.673-5.966,5.966-5.966Z",
    fill: "#b2d4f1",
    className: "svgShape colorf1bdb2-139 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.375,
    cy: 640.976,
    rx: 7.059,
    ry: 20.086,
    transform: "rotate(-80.097 515.377 640.976)",
    fill: "#494a4a",
    className: "svgShape color49494a-140 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500.302,633.483h14.947c2.023,0,3.665,1.642,3.665,3.665v4.601c0,2.023-1.642,3.665-3.665,3.665h-14.947c-3.293,0-5.966-2.673-5.966-5.966h0c0-3.293,2.673-5.966,5.966-5.966Z",
    transform: "rotate(-170.097 506.627 639.448)",
    fill: "#b2d4f1",
    className: "svgShape colorf1bdb2-141 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.944,
    height: 37.733,
    x: 478.112,
    y: 482.075,
    rx: 7.061,
    ry: 7.061,
    fill: "#b2d4f1",
    className: "svgShape colorf1bdb2-142 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.746,
    cy: 472.931,
    rx: 5.611,
    ry: 5.295,
    transform: "rotate(-5.198 469.737 472.923)",
    fill: "#b2d4f1",
    className: "svgShape colorf1bdb2-143 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.746,
    cy: 472.931,
    rx: 3.552,
    ry: 3.352,
    transform: "rotate(-5.198 469.737 472.923)",
    fill: "#80bcf0",
    className: "svgShape colorf09c80-144 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.044,
    cy: 470.702,
    rx: 4.872,
    ry: 5.295,
    transform: "rotate(-5.198 502.035 470.691)",
    fill: "#b2d4f1",
    className: "svgShape colorf1bdb2-145 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.044,
    cy: 470.702,
    rx: 3.084,
    ry: 3.352,
    transform: "rotate(-5.198 502.035 470.691)",
    fill: "#80bcf0",
    className: "svgShape colorf09c80-146 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.93,443.648h3.485c7.89,0,14.296,6.406,14.296,14.296v18.353c0,8.591-6.975,15.565-15.565,15.565h-.945c-8.591,0-15.565-6.975-15.565-15.565v-18.353c0-7.89,6.406-14.296,14.296-14.296Z",
    transform: "rotate(-5.198 485.667 467.752)",
    fill: "#b2d4f1",
    className: "svgShape colorf1bdb2-147 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.999,456.946c-.818-.391-1.721-.574-2.649-.49-3.216.293-5.538,3.671-5.186,7.541.021.233.051.466.092.692-.04.009-.085.013-.126.016-.838.076-1.665.046-2.471-.075-5.6-.866-10.251-6.332-10.888-13.334-.729-8.009,4.071-14.99,10.72-15.595,2.096-.191,4.129.275,5.949,1.26.611.325,1.193.707,1.748,1.147,4.142-4.88,9.686-8.081,15.991-8.655.564-.051,1.126-.082,1.685-.088h.008c1.271-.021,2.524.07,3.762.267,1.011.153,2.009.383,2.987.679h.004c2.4,1.202,4.454,3.302,5.85,5.962,4.432,1.883,7.85,6.751,8.393,12.721,0,0,.011.169.035.477.004.045.009.094.009.149.439,7.81-4.277,14.499-10.754,15.088-3.727.339-7.245-1.412-9.745-4.437-1.32.62-2.742,1.02-4.242,1.156-3.167.288-6.214-.641-8.81-2.456-.307-.427-2.101-1.749-2.482-2.08",
    fill: "#333333",
    className: "svgShape color333333-148 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.838,489.419s5.735,6.433,18.591-.88c0,0,2.952,9.445-18.237,10.879l-.354-9.999Z",
    fill: "#7baedb",
    className: "svgShape colordb8e7b-149 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.436,596.186c5.953,3.131,14.39,6.614,24.913,8.124,24.041,3.45,43.018-5.687,50.368-9.749-1.173-30.509-2.347-61.019-3.52-91.528-10.654-8.429-20.398-11.983-23.141-10.092-.404.279-1.043,10.603-8,11.988-5.389,1.073-12.305-1.813-12.943-10.51-.313-4.266-14.487.69-24.831,10.751-.948,30.339-1.896,60.677-2.844,91.016Z",
    fill: "#efefef",
    className: "svgShape colorefefef-150 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.767,593.334s-51.531-12.02-62.28-2.572c0,0-20.54,24.648,36.151,43.134l14.906,5.34s.421,10.681,5.903,11.502c0,0,53.135-4.118,96.27-40.263,0,0,16.021-11.087,7.394-27.93,0,0-11.392-10.056-53.143,10.788,0,0-22.652,5.746-31.382,8.571l-13.818-8.571Z",
    fill: "#3a3a3a",
    className: "svgShape color3a3a3a-151 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.211,634.992c14.935-9.324,30.153-18.194,45.581-26.678,13.607-7.136,27.188-14.762,41.938-19.287,2.128-.523,4.295-1.105,6.509-.957-2.214-.116-4.369.497-6.484,1.049-14.669,4.726-28.226,12.312-41.778,19.535-15.227,8.239-30.907,17.425-45.766,26.339h0Z",
    fill: "#aeafaf",
    className: "svgShape coloraeaeaf-152 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.505,595.738c22.913,4.302,45.694,11.273,65.893,23.107-2.581-1.372-5.101-2.855-7.756-4.078-18.356-8.995-38.164-14.868-58.136-19.029h0Z",
    fill: "#aeafaf",
    className: "svgShape coloraeaeaf-153 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.663,544.663c.666-.927,1.956-1.158,2.987-.669,0,0,8.165,3.819,8.682,3.998,2.458.851,6.21,3.168,6.658,3.447.029.018.065.016.09-.007.622-.567-1.277-3.789-1.277-3.789-1.238-1.735-.818-4.172.938-5.39,1.016-.705,2.425-.388,3.144.618l4.383,6.142s.007.009.012.013l7.536,11.427c.029.026,1.497-3.129,1.477-3.096l-5.218,8.981c-.018.031,7.012-5.571,4.117-.702l-22.422.509-2.009-.144c-1.419-.102-2.496-1.346-2.394-2.765l.015-.206c.076-1.056.786-1.922,1.729-2.254l-1.962-.141c-1.419-.102-2.496-1.346-2.394-2.765l.015-.206c.098-1.357,1.243-2.39,2.584-2.389l-2.638-.19c-1.419-.102-2.496-1.346-2.394-2.765l.015-.206c.098-1.367,1.258-2.405,2.611-2.39l-3.404-1.613c-1.276-.605-1.745-2.247-.88-3.451Z",
    fill: "#9ec8ed",
    className: "svgShape coloreda99e-154 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m515.481,514.578l15.002,28.794c.243.466-.06,1.031-.583,1.086l-34.976,3.678s-2.183,5.423-1.699,13.749c.161,2.765.398,4.635,3.373,5.034l50.338-6.669c5.71-.757,9.002-6.889,6.469-12.062-3.269-6.678-7.572-15.217-11.188-21.543-7.551-13.208-11.606-17.578-11.606-17.578l-15.131,5.512Z",
    fill: "#efefef",
    className: "svgShape colorefefef-155 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m522.197,503.034s5.767,2.647,8.414,6.033l-3.188,7.794-10.495-2.81,5.269-11.017Z",
    fill: "#efefef",
    className: "svgShape colorefefef-156 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.767,518.398s16.156-14.304,36.746-.671c0,0,15.839-10.28,31.678-1.175l-3.801,41.745s-23.758-6.958-62.722,0l-1.901-39.899Z",
    fill: "#e3effa",
    className: "svgShape colorfaf8e3-157 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.767,521.641s16.156-14.304,36.746-.671c0,0,15.839-10.28,31.678-1.175l-3.801,41.745s-23.758-6.958-62.722,0l-1.901-39.899Z",
    fill: "#6f899f",
    className: "svgShape color6f9f9e-158 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "501.018 520.439 500.705 558.456 497.929 558.456 497.929 520.439 499.354 521.655 501.018 520.439",
    fill: "#85b4dd",
    className: "svgShape colorddc385-159 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.37 526.615-2.019 10.097s-7.959-2.376-17.225 0l-1.426-10.691s12.83-5.108 20.67.594ZM465.499 560.114s19.284-4.118 31.005-2.851c0 0-.832-.832 0-1.366 0 0-5.643-1.544-31.005 3.029 0 0-.832.713 0 1.188ZM526.481 560.585s-15.622-4.055-25.239-3.369c0 0 .706-.668.044-1.142 0 0 4.66-1.111 25.233 3.518 0 0 .656.622-.039.993Z",
    fill: "#85b4dd",
    className: "svgShape colorddc385-160 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.724,541.864c-.736-.872-2.04-1.001-3.031-.434,0,0-7.842,4.445-8.344,4.663-2.385,1.04-5.944,3.643-6.369,3.956-.027.02-.064.021-.091,0-.664-.517.978-3.877.978-3.877,1.099-1.826.49-4.223-1.356-5.3-1.068-.623-2.448-.198-3.086.862l-3.89,6.466s-.007.01-.01.014l-6.621,11.98c-.027.028-1.736-3.003-1.714-2.971l5.903,8.547c.02.03-7.426-5.007-4.159-.378l22.393-1.243,1.992-.301c1.407-.212,2.384-1.537,2.171-2.943l-.031-.204c-.158-1.047-.934-1.855-1.9-2.112l1.945-.294c1.406-.212,2.384-1.537,2.171-2.943l-.031-.204c-.203-1.346-1.426-2.286-2.763-2.18l2.615-.395c1.407-.212,2.384-1.537,2.171-2.943l-.031-.204c-.205-1.355-1.442-2.3-2.79-2.179l3.267-1.874c1.225-.703,1.565-2.376.608-3.509Z",
    fill: "#9ec8ed",
    className: "svgShape coloreda99e-161 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.708,515.681l-12.709,29.877c-.206.484.141,1.023.666,1.037l35.156.937s2.599,5.237,2.767,13.574c.056,2.769-.035,4.652-2.969,5.281l-50.705-2.72c-5.752-.309-9.512-6.165-7.391-11.521,2.737-6.912,6.361-15.762,9.473-22.351,6.497-13.757,10.198-18.43,10.198-18.43l15.515,4.314Z",
    fill: "#efefef",
    className: "svgShape colorefefef-162 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.611,496.881s-18.242,8.939-22.955,21.88l6.8,10.52,12.765-16.76,9.289-11.849-5.899-3.79Z",
    fill: "#efefef",
    className: "svgShape colorefefef-163 selectable"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduBlack);
export default __webpack_public_path__ + "static/media/eduBlack.2f53aa4dc49db928e882a97347b63856.svg";
export { ForwardRef as ReactComponent };